import { render } from "./Index_concept_m.vue?vue&type=template&id=3899d636&scoped=true"
import script from "./Index_concept_m.vue?vue&type=script&lang=js"
export * from "./Index_concept_m.vue?vue&type=script&lang=js"

import "./Index_concept_m.vue?vue&type=style&index=0&id=3899d636&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3899d636"

export default script